@if (iconClass) {
<i [ngClass]="iconClass"
  [style.color]="iconColor"></i>
}
<span class="vi-text"
  class="size-{{size}}"
  [style.color]="textColor"
  [style.font-weight]="fontWeight"
  [attr.aria-label]="text"
  [attr.title]="text">
  {{text}}
</span>
